import routerOptions0 from "/data/www/musikum_portal/prod/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.6.2_db0@0.2.3_eslint@8.49.0_ioredis@5.4.2_ma_5b5lnjm2odf2fgj57fbbrw6u6a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}